export const getFilterDate = (date: string | Date | undefined | number) => {
  if (!date) {
    return undefined;
  }
  return new Date(date);
};
